import { useQuery } from '@tanstack/react-query';

import { businessToolFormQueryKeys } from '../businessToolForm-qk';
import { BusinessToolFormApi } from '../businessToolForm.api';

export const useGetBusinessPlanChapters = ({ id, enabled }: { id: string; enabled: boolean }) => {
  return useQuery({
    queryKey: businessToolFormQueryKeys.businessTool(id),
    queryFn: () => BusinessToolFormApi.getAllChapters(id),
    enabled,
  });
};
